import { getCategoryKeys, getPanels } from '@/features/visualizations/domain/panels';

const DASHBOARD_PATH_BUILDERS = {
  forward: (segmentKey) => `/reports/forward/${encodeURIComponent(segmentKey)}`,
  flex: (segmentKey) => `/reports/flexibility/${encodeURIComponent(segmentKey)}`,
};

let visualizationTargetIndex = null;

export function resolvePredefinedVisualizationTarget(datasetId, visualizationId) {
  const normalizedDatasetId = String(datasetId || '').trim();
  const normalizedVisualizationId = String(visualizationId || '').trim();
  if (!normalizedDatasetId || !normalizedVisualizationId) {
    return null;
  }

  return getVisualizationTargetIndex().get(
    buildVisualizationKey(normalizedDatasetId, normalizedVisualizationId)
  ) || null;
}

function getVisualizationTargetIndex() {
  if (visualizationTargetIndex) {
    return visualizationTargetIndex;
  }

  visualizationTargetIndex = new Map();

  Object.entries(DASHBOARD_PATH_BUILDERS).forEach(([category, buildPath]) => {
    getCategoryKeys(category).forEach((segmentKey) => {
      const panels = getPanels(category, segmentKey);
      if (!Array.isArray(panels)) {
        return;
      }

      panels.forEach((panel) => {
        const key = buildVisualizationKey(panel?.datasetId, panel?.visualizationId);
        if (!key || visualizationTargetIndex.has(key)) {
          return;
        }

        visualizationTargetIndex.set(key, {
          path: buildPath(segmentKey),
          panelId: panel.id,
          category,
          segmentKey,
        });
      });
    });
  });

  return visualizationTargetIndex;
}

function buildVisualizationKey(datasetId, visualizationId) {
  const normalizedDatasetId = String(datasetId || '').trim();
  const normalizedVisualizationId = String(visualizationId || '').trim();
  if (!normalizedDatasetId || !normalizedVisualizationId) {
    return null;
  }

  return `${normalizedDatasetId}:${normalizedVisualizationId}`;
}
